module.exports = __webpack_public_path__ + "img/logo.3a70f236.png";